import { createContext } from 'react'
import {
  DragContextParam,
  FormContextParam,
  QuestionnaireContextParam,
} from './types'
import { AnyType } from 'packages/types'

/**
 * @param param.task - 任务相关信息
 * @param param.questionnaires - 问卷相关配置
 * @param param.setQuestionnaires - 修改问卷相关配置
 */
export const QuestionnaireContext = createContext<QuestionnaireContextParam>(
  null as AnyType
)

/**
 * 问卷题目拖动设置
 */
export const DragContext = createContext<DragContextParam>({
  dragDisabled: false,
  onChangeDragDisabled: () => null,
})

/**
 * 问卷预览表单填写
 */
export const FormContext = createContext<FormContextParam>({
  formValues: {},
  setFormValues: () => null,
  setFinalFormValues: () => null,
  otherInfo: {},
  setOtherInfo: () => null,
})
